interface TruncateProps {
    text: string;
    max?: number;
}

export default function TruncateText({ text, max = 24 }: TruncateProps) {
    const truncated = text.length > max;
    return (
        <span title={truncated ? text : undefined}>
            {truncated ? `${text.slice(0, max)}…` : text}
        </span>
    );
}
